/**
 * Created by nijin on 3/2/17.
 */
import {Component, OnInit, Output, EventEmitter, Input, OnChanges} from '@angular/core';
import {FormGroup, FormBuilder, Validators} from "@angular/forms";
import {GlobalValidator} from "../../shared/validators/global-validator";

@Component({
    selector: 'nuc-loc-attr-form',
    templateUrl: './loc-attribute-form.html',
    styles:[`
    .help-block{
        font-size: 12px;
        }`]
})
export class LocAttrForm implements OnInit, OnChanges {
  locAttrForm: FormGroup;
  isLocAttrSubmitted;
  index: number = null;
  attributeIndex: null;
  isSubmitted: boolean;
  isEdit: boolean;
  @Input() datatypes = [];
  @Input() attributes = [];
   options = [
    {label:'Optional', value:false},
    {label:'Required', value:true}
  ]
  @Input() attribute;
  @Output() add = new EventEmitter<any>();
  @Output() update = new EventEmitter<any>();
  @Output() changeInDt = new EventEmitter<any>();
  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.buildForms();
  }

  ngOnChanges() {
    this.isLocAttrSubmitted = false;
  }

  addLocAttribute(form){
    let data = {attribute:null, field: null };
    if(!form.valid) {
      this.isLocAttrSubmitted = true;
      this.onValueChanged();
      return;
    }
    let name = form.controls['name'].value;
    if(this.attributes && this.attributes.map((attr)=>{return attr.name}).indexOf(name) >-1){
      this.formErrors.name = 'VALIDATIONS.LOCATION.NAME.ALREADY_ADDED';
      this.isLocAttrSubmitted = true;
      return;
    }
    data.attribute = this.attribute ?  this.attribute : form.value;
    data.field = this.attribute ?  form.value : null;
    this.add.emit(data);
    form.reset({required:null, datatype:null});//json,false
    this.isLocAttrSubmitted = false;
  }

  discardChanges(){
    this.isSubmitted = false;
    this.index = null;
    this.isEdit = false;
    this.locAttrForm.reset();
    this.locAttrForm.reset({datatype:null, required:null});//json,false
  }

  updateAttribute(form){
    if(!form.valid){
      this.isLocAttrSubmitted = true;
      this.onValueChanged();
      return;
    }

    if(this.index != null){
      let data = {attribute:form.value, index : this.index, attributeIndex:this.attributeIndex};
      this.update.emit(data);
      this.index =null;
      this.attributeIndex = null;
      form.reset();
      this.isLocAttrSubmitted = false;
      this.isEdit = false;
    }
  }
  setFormValue(attribute, index, attributeIndex?){
    this.index = index;
    this.attributeIndex = attributeIndex;
    this.isEdit = true;
    this.locAttrForm.setValue({name: attribute.name,
      datatype: attribute.datatype,precision:attribute.precision,required:attribute.required});

  }

  buildForms(){
    this.locAttrForm = this.fb.group(
      {
        'name': ['', [
          Validators.required,
          GlobalValidator.jsonKeyValidation,
          Validators.maxLength(20)
        ]
        ],
        'datatype': ['', [
          Validators.required,
        ]
        ],
        'precision': ['', [
          GlobalValidator.numberBetween(0,100)
        ]
        ],
        'required': ['', [
          Validators.required
        ]
        ],
      }


    );
    this.locAttrForm.valueChanges
      .subscribe(data => this.onValueChanged(data));
    this.onValueChanged();
  }
  onValueChanged(data?: any){
    if (!this.locAttrForm) { return; }
    const form = this.locAttrForm;
    for (const field in this.formErrors) {
      // clear previous error message (if any)
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] = messages[key];
        }
      }
    }
  }
  formErrors = {
    'name': '',
    'datatype':'',
    'precision':'',
    'unit':'',
    'required':''
  };
  validationMessages = {
    'name': {
      'required': 'VALIDATIONS.LOCATION.NAME.REQUIRED',
      'maxlength':'VALIDATIONS.LOCATION.NAME.MAX_LENGTH',
      'jsonKey':'VALIDATIONS.LOCATION.NAME.NO_SPECIAL_CHARACTERS',
    },
    'datatype':{
      'required': 'VALIDATIONS.LOCATION.DATA_TYPE.REQUIRED',
    },
    'precision':{
      'invalidRange': 'VALIDATIONS.LOCATION.PRECISION.NUMERIC',
    },
    'unit':{
      'required':'VALIDATIONS.EDIT_ATTRIBUTE.UNIT.REQUIRED'
    },
    'required':{
      'required':'VALIDATIONS.LOCATION.REQUIRED.REQUIRED'
    }
  };

  filterInputNumber(event){
    let keyCode = ('which' in event) ? event.which : event.keyCode;
    let isNotWanted = (keyCode == 69 || keyCode == 101 || keyCode == 43 || keyCode == 45|| keyCode == 46);
    return !isNotWanted;
  }
}



// WEBPACK FOOTER //
// ./src/app/schema/edit-schema/loc-attribute-form.component.ts